module.exports = __webpack_public_path__ + "static/img/znsb_img_ssxxts.e47593c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/znsb_img_ssxxts.png
// module id = K87J
// module chunks = 21